export default "__VITE_ASSET__88584464__"